import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col, Row} from "react-bootstrap";

import {Link} from 'react-router-dom';
import {loadGeneralEnum} from '../actions/enums';
import {countInvoices, loadInvoices} from '../actions/invoices';
import {showModal} from "../actions/modal";
import {resetPage, showMessage} from '../actions';
import {defaultState} from '../reducers/paginate';
import Invoices from '../components/invoice/Invoices';
import {Acl, breadcrumbs} from "../utils";

class InvoicesPage extends Component {

	constructor(props) {
		super(props);

		this.handleFetchData = this.handleFetchData.bind(this);
		this.handleFetchEnums = this.handleFetchEnums.bind(this);
	}

	componentDidMount() {
	}

	componentWillUnmount() {
		this.props.resetPage();
	}

	handleFetchEnums(enums, filter = {}) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], filter)
			}
		}
	}

	handleFetchData(filter) {
		this.props.loadInvoices(filter);
		this.props.countInvoices(filter);
	}

	render() {
		const {page, enums, session} = this.props;

		return (
			<div>
				<Row>
					<Col xs={8}>
						{breadcrumbs([{title: 'invoices'}])}
					</Col>
					<Col xs={4}>
						{Acl.isAllowed(session, Acl.invoice.CREATE) &&
						<Link to={{pathname: "/invoices/new"}} className="btn btn-success pull-right"><span className="fa fa-plus"/> Nová</Link>}
					</Col>
				</Row>
				<Invoices {...page} enums={enums} session={session}
					onFetchEnums={this.handleFetchEnums}
					onFetchData={this.handleFetchData}
					onShowModal={this.props.showModal}
					onShowMessage={this.props.showMessage}
				/>
			</div>
		)
	}
}

InvoicesPage.propTypes = {
	page: PropTypes.object,
	enums: PropTypes.object,
	loadGeneralEnum: PropTypes.func.isRequired,
	loadInvoices: PropTypes.func.isRequired,
	countInvoices: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	resetPage: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	showModal: PropTypes.func.isRequired
};


const mapStateToProps = (state, ownProps) => {
	const {
		pagination: {invoices},
		enums,
		session
	} = state;

	const page = invoices[0] || defaultState;

	return {
		page,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadGeneralEnum,
	loadInvoices,
	countInvoices,
	showMessage,
	resetPage,
	showModal
})(InvoicesPage)
